import { render, staticRenderFns } from "./InfraWrapper.vue?vue&type=template&id=3704293c"
import script from "./InfraWrapper.vue?vue&type=script&lang=js"
export * from "./InfraWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3704293c')) {
      api.createRecord('3704293c', component.options)
    } else {
      api.reload('3704293c', component.options)
    }
    module.hot.accept("./InfraWrapper.vue?vue&type=template&id=3704293c", function () {
      api.rerender('3704293c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/InfraWrapper.vue"
export default component.exports